namespace GeniuzPOS.Purchase {
    export interface ReportPurTaxLongRow {
        Id?: string;
        Lineitemno?: number;
        DocDate?: string;
        TaxInvoiceDate?: string;
        TaxInvoiceNo?: string;
        SupplName?: string;
        SupplTaxId?: string;
        NetAmt?: number;
        VatAmt?: number;
        TotalAmt?: number;
        RefDocNo1?: string;
    }

    export namespace ReportPurTaxLongRow {
        export const idProperty = 'Id';
        export const nameProperty = 'TaxInvoiceNo';
        export const localTextPrefix = 'Purchase.ReportPurTaxLong';
        export const lookupKey = 'Purchase.ReportPurTaxLong';

        export function getLookup(): Q.Lookup<ReportPurTaxLongRow> {
            return Q.getLookup<ReportPurTaxLongRow>('Purchase.ReportPurTaxLong');
        }
        export const deletePermission = '5Purchase:ใบขอซื้อ(PR):อนุมัติ:View';
        export const insertPermission = '5Purchase:ใบขอซื้อ(PR):อนุมัติ:View';
        export const readPermission = '5Purchase:ใบขอซื้อ(PR):อนุมัติ:View';
        export const updatePermission = '5Purchase:ใบขอซื้อ(PR):อนุมัติ:View';

        export declare const enum Fields {
            Id = "Id",
            Lineitemno = "Lineitemno",
            DocDate = "DocDate",
            TaxInvoiceDate = "TaxInvoiceDate",
            TaxInvoiceNo = "TaxInvoiceNo",
            SupplName = "SupplName",
            SupplTaxId = "SupplTaxId",
            NetAmt = "NetAmt",
            VatAmt = "VatAmt",
            TotalAmt = "TotalAmt",
            RefDocNo1 = "RefDocNo1"
        }
    }
}
